import {AppState} from '@/store/state';
import {UiState} from '@/store/ui/state';
import {ToggleDarkMode, SetNavbarVariant, SetSidebarSkin} from '@/store/ui/actions';
import {Component, HostBinding, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {Store} from '@ngrx/store';
import {AppService} from '@services/app.service';
import {Observable} from 'rxjs';

const BASE_CLASSES = 'main-sidebar elevation-4';
@Component({
    selector: 'app-menu-sidebar',
    templateUrl: './menu-sidebar.component.html',
    styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit {
    @HostBinding('class') classes: string = BASE_CLASSES;
    public ui: Observable<UiState>;
    public user;
    public menu = [];
    public darkMode: boolean;

    constructor(
        private router: Router,
        public appService: AppService,
        private store: Store<AppState>
    ) {}

    ngOnInit() {
        this.ui = this.store.select('ui');
        this.ui.subscribe((state: UiState) => {
            this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
            this.darkMode = state.darkMode;
        });
        this.user = this.appService.user;
        this.menu = this.appService.menu;
    }

    goToPedido(){        
        localStorage.removeItem('idPedido');
        this.router.navigate(['/pedido']);
    }
    
    handleDarkModeChange() {
        this.darkMode = !this.darkMode;
        this.store.dispatch(new ToggleDarkMode());
        this.store.dispatch(new SetNavbarVariant("navbar-dark"));
        this.store.dispatch(new SetSidebarSkin("sidebar-dark-primary"));
    }
    logout() {
        this.appService.logout();
    }
}

 /* export const MENU = [
    {
        name: 'Dashboard',
        iconClasses: 'fas fa-tachometer-alt',
        path: ['/']
    },
    {
        name: 'Pedidos',
        iconClasses: 'fas fa-list-alt',        
        children: [
            {
                name: 'Todos',
                iconClasses: 'far fa-circle',
                path: '/pedidos-todos'
            },
            {
                name: 'Hoy',
                iconClasses: 'far fa-circle',
                path: ['/pedidos-hoy']
            },
            {
                name: 'En Proceso',
                iconClasses: 'far fa-circle',
                path: ['/pedidos-en-proceso']
            },
            {
                name: 'Delivery',
                iconClasses: 'far fa-circle',
                path: ['/pedidos-delivery']
            }
        ]
    },
    {
        name: 'Clientes',
        iconClasses: 'fas fa-users',        
        children: [
            {
                name: 'Todos',
                iconClasses: 'far fa-circle',
                path: ['/clientes-todos']
            },
            {
                name: 'Deudores',
                iconClasses: 'far fa-circle',
                path: ['/clientes-deudores']
            }
        ]
    },
    {
        name: 'Productos',
        iconClasses: 'fas fa-tshirt',        
        children: [
            {
                name: 'Todos',
                iconClasses: 'far fa-circle',
                path: ['/productos']
            },
            {
                name: 'Delivery',
                iconClasses: 'far fa-circle',
                path: ['/productos-delivery']
            }
        ]
    },
    {
        name: 'Informes',
        iconClasses: 'fas fa-file-excel',
        path: ['/informes']
    }
]; 
 */